<template>
  <div>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><a href="#">{{ translations('navbar.return_management') }}</a></li>
        <li class="breadcrumb-item active" aria-current="page">{{ translations('replacement.archive_replacement') }}</li>
      </ol>
    </nav>
    <div class="container-fluid main-container">
      <div class="form-inline mb-2">
        <div class="form-group mr-2">
          <router-link class="btn btn-primary" to="new-replacement">{{ translations('common.addition') }}</router-link>
        </div>
        <div class="form-group mr-3">
          <input type="text" class="form-control" v-model="dtSearch" :placeholder="translations('common.keyword_search')">
        </div>
        <div class="form-group">
          <span class="mr-2">{{ translations('common.period') }}</span>
          <button @click="setFilterLastMonth()" class="btn btn-secondary mr-1 mb-2 mb-md-0">{{ translations('replacement.previous_month') }}</button>
          <button @click="setFilterCurrentMonth()" class="btn btn-info mr-3 mb-2 mb-md-0">{{ translations('replacement.current_month') }}</button>
<!--          <input type="date" v-model="dateFrom" class="form-control" @blur='triggerDateFilter("dateFrom")' @focus="tempDateFromField = dateFrom">-->
          <input type="date" v-model="dateFrom" class="form-control">
          <span class="mr-1 ml-1">〜</span>
<!--          <input type="date" v-model="dateTo" class="form-control" @blur='triggerDateFilter("dateTo")' @focus="tempDateToField = dateTo">-->
          <input type="date" v-model="dateTo" class="form-control">
        </div>
      </div>
      <div class="form-inline mb-4 justify-content-between">
        <div class="d-flex flex-wrap align-items-center">
        <div class="form-group mr-1">
          <div class="dropdown">
            <button ref="txtState" class="btn btn-outline-secondary dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              {{ getFilterTxt (replacement_statuses, searchParam.replacement_status_id, 'name', translations('replacement.replacement_status')) }}
            </button>
            <div class="dropdown-menu">
              <a @click.self="selectFilterArg('replacement_status_id', '')" class="dropdown-item" href="#!">&nbsp;</a>
              <template v-for="(status, i) in replacement_statuses">
                <a :key="i" @click.self="selectFilterArg('replacement_status_id', status.id)" class="dropdown-item" href="#!">{{ status.name }}</a>
              </template>
            </div>
          </div>
        </div>
        <div class="form-group mr-1">
          <div class="dropdown">
            <button class="btn btn-outline-secondary dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              {{ getFilterTxt (replacement_states, searchParam.replacement_state_id, 'name', translations('replacement.operation_confirmation')) }}
            </button>
            <div class="dropdown-menu">
              <a @click.self="selectFilterArg('replacement_state_id', '')" class="dropdown-item" href="#!">&nbsp;</a>
              <template v-for="(state, i) in replacement_states">
                <a :key="i" @click.self="selectFilterArg('replacement_state_id', state.id)" class="dropdown-item" href="#!">{{ state.name }}</a>
              </template>
            </div>
          </div>
        </div>
        <div class="form-group mr-3">
          <v-select class="v-select-absolute" :options="makers" label="name" value="id" v-model="maker" :clearable="false" v-on:input="selectFilterArg('maker_id', maker.id)"></v-select>
        </div>
        <div class="form-group">
          <div class="form-check">
            <input class="form-check-input" v-model="searchParam.show_completed" type="checkbox" value="" id="defaultCheck1">
            <label class="form-check-label" for="defaultCheck1">
              {{ translations('replacement.also_display_processed') }}
            </label>
          </div>
        </div>
          <div class="form-group ml-2">
            <div class="form-check">
              <input v-model="displayAll" class="form-check-input pointer-clickable" id="displayAll" type="checkbox" value="" >
              <label class="form-check-label pointer-clickable" for="displayAll">
                {{ translations('common.display_all') }}
              </label>
            </div>
          </div>
        <div class="form-group ml-2">
          <button class="btn btn-primary btn-sm" type="button" @click="submitSearch">{{ translations('common.search') }}</button>
        </div>
        </div>
        <div class="form-group">
          <div class="form-group" style="margin: 1px 0 0 0">
            <button class="btn btn-primary btn-sm" type="button" @click="exportCsv">{{ translations('common.csv_export') }}</button>
          </div>
        </div>
      </div>
      <div class="table-scroll mb-4">
        <v-data-table
          class="table table-striped table-hover table-2000 table-clickable"
          item-key="name"
          :headers="[
            { text: 'No', value: '', sortable: false },
            { text: translations('replacement.replacement_status'), value: 'replacement_status_id' },
            { text: translations('replacement.organization_number'), value: 'reference_number' },
            { text: translations('replacement.processing_date'), value: 'processed_at' },
            { text: translations('replacement.model_number'), value: 'model' },
            { text: translations('replacement.quantity'), value: 'quantity' },
            { text: translations('replacement.unit_price'), value: 'selling_price' },
            { text: translations('replacement.summary'), value: 'remarks' },
            { text: translations('replacement.maker'), value: 'maker_name' },
            { text: translations('replacement.remarks'), value: 'memo' },
            { text: translations('replacement.cost_price'), value: 'row_price' },
            { text: translations('replacement.reason_return'), value: 'replacement_reason_id' },
            { text: translations('replacement.operation_confirmation'), value: 'replacement_state_id' },
            { text: translations('replacement.verification_results'), value: 'test_result' },
            { text: translations('replacement.return_rate'), value: 'replacement_rate' },
          ]"
          :items="replacements"
          :options.sync="options"
          :server-items-length="totalCount"
          hide-default-footer
          @page-count="pageCount = $event"
        >
          <template v-slot:body="{ items }">
            <tbody class="nowrap">
              <template v-if="!isEmpty">
                <tr v-for='(ret, i) in items' :key="i" data-href="" @click="openReplacementDetails(ret)">
                  <td>{{i + 1}}</td>
                  <td>
                    <ul>
                      <template v-for="(detail, ii) in ret.details">
                        <li :key="ii" v-html="setStatusBadge(detail)"></li>
                      </template>
                    </ul>
                  </td>
                  <td>{{ ret.reference_number }}</td>
                  <td>{{ $invoiceTools.formatDate(ret.processed_at) }}</td>
                  <!-- API document says variable is "reference_number" -->
                  <!-- <td>{{ $invoiceTools.formatDate(ret.returned_at) }}</td> -->
                  <td>
                    <ul>
                      <template v-for='(detail, vii) in ret.details'>
                        <li :key="vii">{{ detail.model || '-' }}</li>
                      </template>
                    </ul>
                  </td>
                  <td class="right">
                    <ul>
                      <template v-for="(detail, ix) in ret.details">
                        <li :key="ix">{{ $invoiceTools.parseTxtNum(detail.quantity) }}</li>
                      </template>
                    </ul>
                  </td>
                  <td class="right">
                    <ul>
                      <template v-for="(detail, viii) in ret.details">
                        <li :key="viii">{{ $invoiceTools.parseTxtNum(detail.selling_price) }}</li>
                      </template>
                    </ul>
                  </td>
                  <td>
                    <ul>
                      <template v-for='(detail, vi) in ret.details'>
                        <li :key='vi'>{{ sliceNote(detail.remarks) || '-' }}</li>
                      </template>
                    </ul>
                  </td>
                  <td>
                    <ul>
                      <template v-for='(detail, vi) in ret.details'>
                        <li :key='vi'>{{ detail.maker_name || '-' }}</li>
                      </template>
                    </ul>
                  </td>
                  <td>{{ sliceNote(ret.memo) || '-' }}</td>
                  <td class="right">
                    <ul>
                      <template v-for="(detail, xii) in ret.details">
                        <li :key="xii">{{ $invoiceTools.parseTxtNum(detail.row_price) }}</li>
                      </template>
                    </ul>
                  </td>
                  <td>
                    <ul>
                      <template v-for="(detail, iii) in ret.details">
                        <li :key="iii">{{ $invoiceTools.getObjPropsById(replacement_reasons, detail.replacement_reason_id, 'name') }}</li>
                      </template>
                    </ul>
                  </td>
                  <td>
                    <ul>
                      <template v-for="(detail, iv) in ret.details">
                        <li :key="iv">{{ $invoiceTools.getObjPropsById(replacement_states, detail.replacement_state_id, 'name') }}</li>
                      </template>
                    </ul>
                  </td>
                  <td>
                    <ul>
                      <template v-for='(detail, v) in ret.details'>
                        <li :key="v">{{ detail.test_result || '-' }}</li>
                      </template>
                    </ul>
                  </td>
                  <td class="right">
                    <ul>
                      <template v-for="(detail, x) in ret.details">
                        <li :key="x">{{ detail.replacement_rate || '-' }}</li>
                      </template>
                    </ul>
                  </td>
                </tr>
              </template>
              <template v-else>
                <tr class="odd">
                  <td valign="top" colspan="17" class="dataTables_empty">{{ isEmptyMsg }}</td>
                </tr>
              </template>
            </tbody>
          </template>
        </v-data-table>
      </div>
      <v-pagination v-model="page" :length="pageCount" :total-visible="11"></v-pagination>
      <vue-element-loading :active="isSearching" :is-full-screen="true"/>
    </div>
  </div>
</template>

<script>
import VueElementLoading from 'vue-element-loading'
import { mapState } from 'vuex'
import { saveAs } from 'file-saver'
import Papa from 'papaparse'
import encoding from 'encoding-japanese'
export default {
  name: 'ArchiveReplacement',
  props: {},
  components: {
    VueElementLoading
  },
  data () {
    return {
      replacements: [],
      dateFrom: '',
      dateTo: '',
      dtSearch: '',
      searchParam: {
        replacement_status_id: '',
        replacement_state_id: '',
        maker_id: '',
        show_completed: '',
        start_at: '',
        end_at: ''
      },
      isSearching: false,
      makers: [],
      maker: {},
      isEmpty: false,
      isEmptyMsg: '',
      page: 1,
      pageCount: 0,
      totalCount: 0,
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: [],
        groupBy: [],
        groupDesc: [],
        multiSort: false,
        mustSort: false
      },
      displayAll: false
    }
  },
  computed: {
    ...mapState(['currentLanguage']),
    replacement_reasons () {
      return this.$store.getters['Return/getReasons']
    },
    replacement_statuses () {
      const statuses = this.$store.getters['Replacement/getStatuses']
      return this.translateStatuses(statuses)
    },
    replacement_states () {
      const states = this.$store.getters['Return/getStates']
      return this.translateStates(states)
    }
  },
  watch: {
    searchParam: {
      handler (v) {
        console.log(v)
        // this.initList()
      },
      deep: true
    },
    page () {
      this.getFilterList()
    },
    options: {
      handler () {
        let visitCount = Number(localStorage.getItem('visitCountReplacement')) || 0
        if (visitCount > 0) {
          this.initList()
        }
      },
      deep: true
    }
  },
  created () {
    this.$store.dispatch('Return/checkReasons')
    this.$store.dispatch('Replacement/checkStatuses') // 交換品状態
    this.$store.dispatch('Return/checkStates')
    this.$store.dispatch('Master/checkBillToAdded')

    this.getVenderList()

    const storedFilter = this.$storage.get('ArchiveReplacementParam')
    const sortParams = this.$storage.get('ArchiveReplacementSortParam')
    if (storedFilter) {
      this.searchParam = {
        replacement_status_id: storedFilter.replacement_status_id,
        replacement_state_id: storedFilter.replacement_state_id,
        maker_id: storedFilter.maker_id,
        show_completed: storedFilter.show_completed,
        start_at: storedFilter.start_at,
        end_at: storedFilter.end_at
      }
      this.dtSearch = storedFilter.search
      this.dateFrom = storedFilter.start_at
      this.dateTo = storedFilter.end_at
      if (sortParams) {
        this.options.sortBy = sortParams.orderbys
        this.options.sortDesc = sortParams.is_descs
      }
    } else {
      this.setFilterCurrentMonth()
    }
    this.maker = {
      id: storedFilter ? this.searchParam.maker_id : ''
    }
  },
  mounted () {
  },
  methods: {
    // changeSearch (e) {
    //   this.$storage.set('ArchiveReplacement:dtSearch', e.target.value) // KEEP KEYWORD
    //   this.initList()
    // },

    // triggerDateFilter (source) {
    //   if (source === 'dateFrom' && this.dateFrom !== this.tempDateField) {
    //     this.searchParam.start_at = this.dateFrom
    //     this.initList()
    //   }
    //
    //   if (source === 'dateTo' && this.dateTo !== this.tempDateField) {
    //     this.searchParam.end_at = this.dateTo
    //     this.initList()
    //   }
    // },
    translations (key) {
      const language = require(`@/locales/${this.currentLanguage}.json`)
      const keys = key.split('.')
      let value = language

      for (const k of keys) {
        value = value[k]
        if (!value) break
      }

      return value || key
    },
    translateStatuses (statuses) {
      return statuses.map(status => ({
        ...status,
        name: this.translations(`statuses_replacement.${status.name}`)
      }))
    },
    translateStates (states) {
      return states.map(state => ({
        ...state,
        name: this.translations(`states.${state.name}`)
      }))
    },
    initList () {
      if (this.page !== 1) {
        this.page = 1
      } else {
        this.getFilterList()
      }
    },

    getFilterList (field, val) {
      if (this.isSearching) {
        return
      }

      if (this.displayAll) {
        this.$storage.set('return_display_all', this.displayAll)
        this.options.itemsPerPage = -1 // DISPLAY ALL
      } else {
        this.options.itemsPerPage = 10 // DISPLAY 10 ROWS
      }

      this.isSearching = true

      const params = JSON.parse(JSON.stringify(this.searchParam))

      const offset = (this.page - 1) * this.options.itemsPerPage
      const limit = this.options.itemsPerPage
      const orderbys = JSON.parse(JSON.stringify(this.options.sortBy))
      const isDescs = JSON.parse(JSON.stringify(this.options.sortDesc))

      params.offset = offset
      params.limit = limit
      params.orderbys = orderbys
      params.is_descs = isDescs
      params.search = this.dtSearch
      params.start_at = (this.dateFrom) ? this.dateFrom : ''
      params.end_at = (this.dateTo) ? this.dateTo : ''

      this.$storage.set('ArchiveReplacementSortParam', params)
      this.$storage.set('ArchiveReplacementParam', params)
      console.log('ArchiveReplacement:getFilterList: ', params)

      this.$http.post(this.$api_url.replacement_list, params).then(response => {
        const result = response.data
        console.log('ArchiveReplacement:getFilterList: ', result)
        if (result.status === true) {
          this.isEmpty = false
          this.isEmptyMsg = ''
          this.replacements = result.list
          localStorage.setItem('visitCountReplacement', this.replacements.length)
          this.totalCount = Number(result.total_count)
        } else {
          this.replacements = []
          this.$toastr.error(result.message, this.translations('common.error'))
        }
      }).catch(error => {
        console.log('ArchiveReplacement:API:getFilterList: error: ', error)
        this.isEmpty = true
        this.isEmptyMsg = this.translations('replacement.notice_failed')
        this.$toastr.error(this.isEmptyMsg, this.translations('common.error'))
      }).finally(() => {
        this.isSearching = false
        this.$nextTick(() => {
          this.$vuetify.goTo('.table-scroll', { duration: 0 })
        })
      })
    },
    getVenderList () {
      return this.$http.post(this.$api_url.vander_list).then(response => {
        const result = response.data
        if (result.status === true) {
          this.makers = result.list
        } else {
          return Promise.reject(new Error(result.message))
        }
        this.makers.unshift({ id: '', name: 'メーカー' })
        const filtered = this.makers.filter(v => {
          return v.id === this.maker.id
        })[0]
        this.maker = filtered || { id: '', name: 'メーカー' }
      }).catch(function (error) {
        console.log('ArchiveReplacement:getVenderList:catch(error): ', error)
        return Promise.reject(new Error(this.translations('replacement.notice_failed')))
      })
    },

    selectFilterArg (filter, val) {
      this.searchParam[filter] = val
    },

    getFilterTxt (obj, input, output, _default) {
      if (input) {
        return this.$invoiceTools.getObjPropsById(obj, input, output)
      }
      return _default
    },

    setFilterCurrentMonth () {
      const $date = new Date()
      const y = $date.getFullYear()
      const m = ('0' + ($date.getMonth() + 1)).slice(-2)
      const ld = new Date(y, m, 0)
      const start = y + '-' + m + '-01'
      const end = y + '-' + m + '-' + ('0' + ld.getDate()).slice(-2)

      this.dateFrom = start
      this.dateTo = end

      this.tempDateFromField = this.dateFrom
      this.tempDateToField = this.dateTo

      this.searchParam.start_at = this.dateFrom
      this.searchParam.end_at = this.dateTo
    },

    setFilterLastMonth () {
      const $date = new Date()
      const m = ($date.getMonth() !== 0) ? ('0' + ($date.getMonth())).slice(-2) : 12
      const y = (m !== 12) ? $date.getFullYear() : $date.getFullYear() - 1
      const ld = new Date(y, m, 0)
      const start = y + '-' + m + '-01'
      const end = y + '-' + m + '-' + ('0' + ld.getDate()).slice(-2)

      this.dateFrom = start
      this.dateTo = end

      this.tempDateFromField = this.dateFrom
      this.tempDateToField = this.dateTo

      this.searchParam.start_at = this.dateFrom
      this.searchParam.end_at = this.dateTo
      this.initList()
    },

    openReplacementDetails (ret) {
      this.$router.push({ name: 'single-replacement', query: { replacement_id: ret.id } })
    },

    setStatusBadge (detail) {
      let statusName = this.$invoiceTools.getObjPropsById(this.replacement_statuses, detail.replacement_status_id, 'name')
      let bClass = ''
      switch (detail.replacement_status_id) {
        case 1:
          bClass = ' badge-replacement-misyori'
          break
        case 2:
          bClass = ' badge-replacement-hensoumachi'
          break
        case 3:
          bClass = ' badge-replacement-syorizumi'
          break
      }
      return '<span class="badge ' + bClass + '">' + statusName + '</span>'
    },

    submitSearch () {
      this.initList()
    },

    sliceNote (note) {
      let text = ''
      if (note) {
        let noteLength = note.length
        text = noteLength > 15 ? note.slice(0, 15) + '.....' : note
      }
      return text
    },

    exportCsv (field, val) {
      if (this.isSearching) {
        return
      }

      this.isSearching = true

      const params = JSON.parse(JSON.stringify(this.searchParam))

      const orderbys = JSON.parse(JSON.stringify(this.options.sortBy))
      const isDescs = JSON.parse(JSON.stringify(this.options.sortDesc))

      params.orderbys = orderbys
      params.is_descs = isDescs
      params.search = this.dtSearch
      params.start_at = (this.dateFrom) ? this.dateFrom : ''
      params.end_at = (this.dateTo) ? this.dateTo : ''

      this.$storage.set('ArchiveReplacementSortParam', params)
      this.$storage.set('ArchiveReplacementParam', params)
      console.log('ArchiveReplacement:exportCsv: ', params)

      this.$http.post(this.$api_url.replacement_csv, params).then(response => {
        const result = response.data
        console.log('ArchiveReplacement:getFilterList: ', result)
        if (result.status === true) {
          this.isEmpty = false
          this.isEmptyMsg = ''
          this.saveCsv_(result.list)
        } else {
          this.replacements = []
          this.$toastr.error(result.message, this.translations('common.error'))
        }
      }).catch(error => {
        console.log('ArchiveReplacement:API:getFilterList: error: ', error)
        this.isEmpty = true
        this.isEmptyMsg = this.translations('replacement.notice_failed')
        this.$toastr.error(this.isEmptyMsg, this.translations('common.error'))
      }).finally(() => {
        this.isSearching = false
        this.$nextTick(() => {
          this.$vuetify.goTo('.table-scroll', { duration: 0 })
        })
      })
    },

    saveCsv_ (list) {
      const data = []
      list.forEach(item => {
        item.details.forEach(detail => {
          const replacementStatus = this.$invoiceTools.getObjPropsById(this.replacement_statuses, detail.replacement_status_id, 'name')
          const replacementReasons = this.$invoiceTools.getObjPropsById(this.replacement_reasons, detail.replacement_reason_id, 'name')
          const replacementStates = this.$invoiceTools.getObjPropsById(this.replacement_states, detail.replacement_state_id, 'name')
          data.push([
            replacementStatus,
            item.reference_number,
            item.processed_at,
            detail.model,
            detail.quantity,
            detail.selling_price,
            detail.remarks,
            detail.maker_name,
            item.memo,
            this.$invoiceTools.parseTxtNum(detail.row_price),
            replacementReasons,
            replacementStates,
            detail.test_result,
            detail.replacement_rate
          ])
        })
      })

      let csv = ''
      csv = Papa.unparse({
        fields: [
          this.translations('replacement.replacement_status'),
          this.translations('replacement.organization_number'),
          this.translations('replacement.processing_date'),
          this.translations('replacement.model_number'),
          this.translations('replacement.quantity'),
          this.translations('replacement.unit_price'),
          this.translations('replacement.summary'),
          this.translations('replacement.maker'),
          this.translations('replacement.remarks'),
          this.translations('replacement.cost_price'),
          this.translations('replacement.reason_return'),
          this.translations('replacement.operation_confirmation'),
          this.translations('replacement.verification_results'),
          this.translations('replacement.return_rate')
        ],
        data: data
      })

      const unicodeList = encoding.stringToCode(csv)
      const sjisArray = encoding.convert(unicodeList, 'SJIS', 'UNICODE')
      const uInt8List = new Uint8Array(sjisArray)
      const content = new Blob([uInt8List], { type: 'text/csv' })
      const d = new Date()
      const filename = this.translations('replacement.replacement_') + d.getFullYear() +
        ('0' + (d.getMonth() + 1)).slice(-2) +
        ('0' + d.getDate()).slice(-2) + '_' +
        ('0' + d.getHours()).slice(-2) +
        ('0' + d.getMinutes()).slice(-2) +
        ('0' + d.getSeconds()).slice(-2) + '.csv'
      saveAs(content, filename)
      this.isLoading = false
    }
  }
}
</script>

<style>
#tbl-replacement{
  margin-top: 0 !important
}
</style>
